import React from 'react';
import { Navigate } from 'react-router-dom';
import { useSubscription } from '@/contexts/SubscriptionContext';
import FeatureLock from './FeatureLock';

interface FeatureProtectedRouteProps {
  feature: 'forms' | 'checklists' | 'messaging' | 'assets';
  children: React.ReactNode;
}

/**
 * Route protection component that checks if user has access to a feature
 * If not, shows FeatureLock overlay or redirects to subscription page
 */
const FeatureProtectedRoute: React.FC<FeatureProtectedRouteProps> = ({ feature, children }) => {
  const { hasFeature, isLoading } = useSubscription();

  if (isLoading) {
    return (
      <div className="min-h-screen bg-gray-50 flex items-center justify-center">
        <div className="text-center">
          <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-primary-600 mx-auto mb-4"></div>
          <p className="text-gray-600">Loading...</p>
        </div>
      </div>
    );
  }

  if (!hasFeature(feature)) {
    // Wrap children in FeatureLock to show upgrade prompt
    return (
      <FeatureLock feature={feature}>
        {children}
      </FeatureLock>
    );
  }

  return <>{children}</>;
};

export default FeatureProtectedRoute;

